import { render, staticRenderFns } from "./DocumentOcrModal.vue?vue&type=template&id=1e5d158c&scoped=true&"
import script from "./DocumentOcrModal.vue?vue&type=script&lang=js&"
export * from "./DocumentOcrModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOcrModal.vue?vue&type=style&index=0&id=1e5d158c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d158c",
  null
  
)

component.options.__file = "DocumentOcrModal.vue"
export default component.exports